import { defineMessages } from 'react-intl';

const messages = defineMessages({
  connections: {
    id: 'am-connections.connections-title',
    defaultMessage: 'Connections',
  },
  download: {
    id: 'am-connections.download',
    defaultMessage: 'Download',
  },
  connLastExport: {
    id: 'am-connections.connections-last-export',
    defaultMessage: '{count, number} {count, plural, one {connection} other {connections} } since last export on {date} {time}',
  },
  showingConnectionsCount: {
    id: 'am-connections.showing-connections-count',
    defaultMessage: 'Showing 1-{count, number} of {total, number} student connections',
  },
  noConnections: {
    id: 'am-connections.no-connections',
    defaultMessage: 'No student connections were found.',
  },
  noPermissions: {
    id: 'am-connections.no-permissions',
    defaultMessage: 'You do not have permission to access this data.',
  },
  temporarilyUnavailable: {
    id: 'am-connections.temporarilyUnavailable',
    defaultMessage: 'Your Intersect Connections are temporarily unavailable. Please try again later.',
  },
  notApplicable: {
    id: 'am-connections.notApplicable',
    defaultMessage: 'N/A',
  },
  classOf: {
    id: 'am-connections.class-of',
    defaultMessage: 'Class of {year}',
  },
  bornOn: {
    id: 'am-connections.born-on',
    defaultMessage: 'Born on {date}',
  },
  gpa: {
    id: 'am-connections.gpa',
    defaultMessage: 'GPA',
  },
  ceeb: {
    id: 'am-connections.ceeb',
    defaultMessage: 'CEEB: {value}',
  },
  addedOn: {
    id: 'am-connections.added-on',
    defaultMessage: 'Added on {date}',
  },
  disconnectedOn: {
    id: 'am-connections.disconnected-on',
    defaultMessage: 'Disconnected on {date}',
  },
  loading: {
    id: 'am-connections.loading',
    defaultMessage: 'Loading student connections...',
  },
  tableCaption: {
    id: 'am-connections.table-caption',
    defaultMessage: 'ActiveMatch Student Connections',
  },
  showMore: {
    id: 'am-connections.show-more',
    defaultMessage: 'Show {inc, number} More',
  },
  historical: {
    id: 'am-connections.historical',
    defaultMessage: 'Historical',
  },
  historicalHeading: {
    id: 'am-connections.historical-heading',
    defaultMessage: 'Historical: {txt}',
  },
  historicalDays: {
    id: 'am-connections.historical-days',
    defaultMessage: 'Last {days} days',
  },
  bySchoolYear: {
    id: 'am-connections.by-school-year',
    defaultMessage: 'By School Year',
  },
  sinceLastExport: {
    id: 'am-connections.since-last-export',
    defaultMessage: 'Since Last Export',
  },
  schoolYear: {
    id: 'am-connections.school-year',
    defaultMessage: 'School Year: {year}',
  },
  downloadingConnections: {
    id: 'am-connections.downloading-connections',
    defaultMessage: 'Downloading student connections ...',
  },
  downloadReady: {
    id: 'am-connections.download-ready',
    defaultMessage: 'Download ready',
  },
  cancel: {
    id: 'am-connections.cancel',
    defaultMessage: 'Cancel',
  },
  connection: {
    id: 'am-connections.connection',
    defaultMessage: 'Student Connection',
  },
  noExportsYet: {
    id: 'am-connections.no-exports-yet',
    defaultMessage: 'No exports yet',
  },
  name: {
    id: 'am-connections.name',
    defaultMessage: 'Name',
  },
  source: {
    id: 'am-connections.source',
    defaultMessage: 'Source',
  },
  genderEthnicity: {
    id: 'am-connections.genderEthicity',
    defaultMessage: 'Gender / Ethnicity',
  },
  birthDate: {
    id: 'am-connections.birthDate',
    defaultMessage: 'Birth Date',
  },
  gradeYearGPA: {
    id: 'am-connections.gradeYearGPA',
    defaultMessage: 'Grad Year / GPA',
  },
  schoolNameCEEB: {
    id: 'am-connections.schoolNameCeeb',
    defaultMessage: 'School Name / CEEB',
  },
  contactAddress: {
    id: 'am-connections.contactAddress',
    defaultMessage: 'Contact / Address',
  },
  majors: {
    id: 'am-connections.majors',
    defaultMessage: 'Majors',
  },
  previousCollegeCreditsEarned: {
    id: 'am-connections.previousCollegeCreditsEarned',
    defaultMessage: 'Previous College / Credits Earned',
  },
  transferBy: {
    id: 'am-connections.transferBy',
    defaultMessage: 'Desired Start Date',
  },
  createdModified: {
    id: 'am-connections.createdModified',
    defaultMessage: 'Created / Modified',
  },
});

export default messages;
